import { CategoryData } from '../../../../types/types';

export const temps: CategoryData = {
    // Jours
    'ⲫⲟⲟⲩ': {
        translation: 'Aujourd\'hui',
        translationEn: 'Today',
        illustration: '📅'
    },
    'ⲣⲁⲥϯ': {
        translation: 'Demain',
        translationEn: 'Tomorrow',
        illustration: '🌅'
    },
    'ⲛⲥⲁϥ': {
        translation: 'Hier',
        translationEn: 'Yesterday',
        illustration: '🌙'
    },
    'ⲙⲉⲛⲉⲛⲥⲁ ⲣⲁⲥϯ': {
        translation: 'Après-demain',
        translationEn: 'Day after tomorrow',
        illustration: '📆'
    },
    'ⲛⲥⲁϥ ⲛⲥⲁϥ': {
        translation: 'Avant-hier',
        translationEn: 'Day before yesterday',
        illustration: '📅'
    },

    // Moments de la journée
    'ⲧⲟⲟⲩⲉ': {
        translation: 'Matin',
        translationEn: 'Morning',
        illustration: '🌄'
    },
    'ⲉϩⲟⲟⲩ': {
        translation: 'Jour/Soleil',
        translationEn: 'Day/Sun',
        illustration: '☀️'
    },
    'ⲣⲟⲩϩⲉ': {
        translation: 'Soir',
        translationEn: 'Evening',
        illustration: '🌆'
    },
    'ⲉϫⲱⲣϩ': {
        translation: 'Nuit',
        translationEn: 'Night',
        illustration: '🌙'
    },

    // Périodes
    'ⲁⲃⲟⲧ': {
        translation: 'Mois/Lune',
        translationEn: 'Month/Moon',
        illustration: '🌕'
    },
    'ⲣⲟⲙⲡⲓ': {
        translation: 'Année',
        translationEn: 'Year',
        illustration: '📅'
    },
    'ϣⲟⲙⲧ': {
        translation: 'Semaine',
        translationEn: 'Week',
        illustration: '📅'
    }
};

export default temps;